// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"d1b78e78","581":"d1b78e78"}[chunkId] + ".chunk.css";
};